import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import ResearchMarriageNonResidentNotificationsShared from '../../research-notifications/research-marriage-non-resident';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchMarriageNonResidentNotificationsCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchMarriageNonResidentNotificationsCivilStatusShared = ({
  scope,
  items,
}: ResearchMarriageNonResidentNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const editSipoUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/non-residenti/persona-sipo`;
  }, [goBackUrl]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <ResearchMarriageNonResidentNotificationsShared
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        items={items}
        editSipoUrl={editSipoUrl}
      />
    </Fragment>
  );
};

ResearchMarriageNonResidentNotificationsCivilStatusShared.displayName =
  'Research Marriage Non Resident Notifications CivilStatusShared component';

export default ResearchMarriageNonResidentNotificationsCivilStatusShared;
